<script lang="ts" setup>
    const props = defineProps<{ visibility?: '' | 'after' | 'before' | 'both' }>();
    const { isDraftModeEnabled } = useDraftMode();
    defineOptions({
        inheritAttrs: false
    });

    const { t } = useI18n();

    const label = computed(() => {
        if (props.visibility === 'before') {
            return t('previewBorder.beforeLogin');
        } else if (props.visibility === 'after') {
            return t('previewBorder.afterLogin');
        } else {
            return '';
        }
    });
</script>

<template>
    <template v-if="isDraftModeEnabled">
        <div
            class="preview-border"
            :class="{
                afterLogin: props.visibility === 'after',
                beforeLogin: props.visibility === 'before'
            }"
            :style="{ '--preview-label': `'${label}'` }"
        >
            <div
                class="slot-wrapper"
                v-bind="$attrs"
            >
                <slot></slot>
            </div>
        </div>
    </template>

    <template v-else>
        <slot />
        {{ ' ' /* do not remove this - this fixes a duplication error */ }}
    </template>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/global/preview-border.scss';
</style>
